import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

export const AdditionalInformationContainer = styled.div<{
  isLive?: boolean;
  borderless?: boolean;
}>`
  margin-bottom: 30px;

  ${(props) =>
    props.isLive &&
    `
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
  `}
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.text.primary};
  flex: 1;
`;

export const FormFieldsContainer = styled.div<{ borderless?: boolean }>`
  ${(props) =>
    !props.borderless &&
    `
    border: 1px solid ${colors.border};
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: ${colors.white};
    margin-top: 16px;
  `}

  ${(props) =>
    props.borderless &&
    `
    margin-top: 16px;
  `}
`;

export const QuestionsContainer = styled.div<{ hasWaiver: boolean }>`
  ${(props) =>
    props.hasWaiver &&
    `
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.border};
  `}
`;

export const WaiverContainer = styled.div`
  margin-top: 20px;
`;
